import { Circle, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import { IngestionActionKeyGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import { ActionConfig } from './types';
import { Icon } from '~/packages/common-frontend/components/icons';
import { getIngestionPayloadWithAssert } from '~/packages/common-frontend/utils';

// Exports
export const ingestion: Record<IngestionActionKeyGQLType, ActionConfig> = {
  success: {
    Component: function InsertDeliverableItemComponent({ event }) {
      const { targetName } = event;
      const payload = getIngestionPayloadWithAssert(event);
      const {
        origin: [originPath],
      } = payload;
      return (
        <Text>
          <strong>{`Successful ${targetName}`}</strong>
          {` of file `}
          <strong>{`${originPath}`}</strong>
        </Text>
      );
    },
    icon: <Icon icon="check" />,
  },
  failed: {
    Component: function InsertDeliverableItemComponent({ event }) {
      const { targetName } = event;
      const payload = getIngestionPayloadWithAssert(event);
      const {
        origin: [originPath],
        failedOps,
      } = payload;
      return (
        <Text>
          <strong>{`${failedOps} failed ${targetName}${
            failedOps > 1 ? 's' : ''
          }`}</strong>
          {` of file `}
          <strong>{`${originPath}`}</strong>
        </Text>
      );
    },
    PanelComponent: function InsertDeliverableItemPanelComponent({ event }) {
      const payload = getIngestionPayloadWithAssert(event);
      const { messages } = payload;
      return messages ? (
        <>
          <Heading as="h6" size="md" mt="35px" mb="10px">
            {`Error Message${messages.length > 1 ? 's' : ''}`}
          </Heading>
          {messages.map((message) => (
            <Flex key={message} alignItems="center">
              <Circle size="20px">
                <Icon icon="triangle-exclamation" color="red.300" />
              </Circle>
              <Text>{message}</Text>
            </Flex>
          ))}
        </>
      ) : (
        <Text>No error messages to show for this failed ingestion</Text>
      );
    },
    icon: <Icon icon="xmark-large" />,
  },
};
